module.exports = __webpack_public_path__ + "static/img/case-1linyedata.d339b7ca.jpg";